// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3pcXX","notes":"Notes_notes__2uWSR","note":"Notes_note__2nnAT","markdown":"Notes_markdown__2C4Jo"};